import { useState } from "react";
import { saveSettings, type Settings } from "../api";

export function Login({ onSave }: { onSave: (s: Settings) => void }) {
    const [apiBase, setApiBase] = useState("");
    const [token, setToken] = useState("");
    const [err, setErr] = useState<string | null>(null);

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setErr(null);
        try {
            // Smoke-test: hit /health to verify the URL is reachable. Auth comes later.
            const res = await fetch(new URL("/health", apiBase).toString());
            if (!res.ok) throw new Error(`API responded ${res.status}`);
            const settings = { apiBase: apiBase.replace(/\/$/, ""), token };
            saveSettings(settings);
            onSave(settings);
        } catch (e) {
            setErr((e as Error).message);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center px-6">
            <form
                onSubmit={handleSubmit}
                className="w-full max-w-md bg-okiru-panel border border-okiru-muted/20 rounded-2xl p-8 shadow-xl"
            >
                <h1 className="text-2xl font-semibold mb-1">Okiru Analytics</h1>
                <p className="text-okiru-muted text-sm mb-6">Connect to your API worker.</p>

                <label className="block text-sm mb-2">API base URL</label>
                <input
                    type="url"
                    required
                    placeholder="https://okiru-api.your-subdomain.workers.dev"
                    value={apiBase}
                    onChange={(e) => setApiBase(e.target.value)}
                    className="w-full bg-okiru-bg border border-okiru-muted/30 rounded-lg px-3 py-2 mb-4 focus:border-okiru-accent outline-none"
                />

                <label className="block text-sm mb-2">API token</label>
                <input
                    type="password"
                    required
                    placeholder="Bearer token"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    className="w-full bg-okiru-bg border border-okiru-muted/30 rounded-lg px-3 py-2 mb-6 focus:border-okiru-accent outline-none"
                />

                {err && <p className="text-red-400 text-sm mb-4">{err}</p>}

                <button
                    type="submit"
                    className="w-full bg-okiru-accent text-okiru-bg font-medium py-2 rounded-lg hover:opacity-90 transition"
                >
                    Connect
                </button>
            </form>
        </div>
    );
}
